import React, { useState } from 'react';
import HomeLeftBar from '@common_components/layout/LeftBarManager';
//import HomeTopBar from '../components/menu/HomeTopBar';
import Footer from '../@common_components/global/footer.component';

function ProfilView() {
  const [ isPopupVisible, setPopupVisible ] = useState( false );

  const togglePopup = () => {
    setPopupVisible( !isPopupVisible );
  };

  return (
    <div>
      <div className='flex min-h-screen w-screen bg-white-base text-black relative'>
        <HomeLeftBar variant='basic' />
        <div className='w-full pr-10 ml-32'>
          {/*<HomeTopBar title='Profil' />*/}
          <button onClick={togglePopup}>Open</button>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ProfilView;
